export class HolidayModel {
    Holiday_Id: number = 0;
    Date : Date = new Date();
    Name: string ="";
    Active: boolean = false;
    Created_By: number = 0;
    CanDelete : boolean = false;
}